import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { httpLink } from './links/http-link';
import { setContext } from '@apollo/client/link/context';

const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key, value) => (key === '__typename' ? undefined : value);
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
  }
  return forward(operation).map((data) => {
    return data;
  });
});

const authLink = setContext((_, { headers }) => {
  let token;
  try {
    token = JSON.parse(sessionStorage.getItem('token')).token;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const link = ApolloLink.from([cleanTypeName, authLink.concat(httpLink)]);

export const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    typePolicies: {
      RTSPPush: {
        keyFields: ['container'],
      },
    },
  }),
});
